import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { StateProvider } from './providers/StateProvider';
import { initialState } from './store/InitialState';
import { reducer } from './store/Reducer';
import logClient, { LogLevels } from 'c9-js-log-client';
import './assets/styles/common.css';

let context: any = window || {};

context.OnsaPersonalInjury = (function () {
  function boostrapApplication(config: any, boostrapElement: HTMLElement) {
    const basename = boostrapElement.getAttribute('data-basename') || '/';
    const appName = 'onsa-personal-injury';
    const c9log = logClient(config.logger, appName, LogLevels.debug);
    c9log.debug(`Starting up application ${c9log.appName}, basename ${basename}`).catch((err: any) => {
      console.log('logger service has failed', err);
    });

    const root = ReactDOM.createRoot(boostrapElement);
    root.render(
      <Router basename={basename}>
        <StateProvider reducer={reducer} initialState={initialState}>
          <App {...config} basename={basename} c9log={c9log} />
        </StateProvider>
      </Router>
    );
  }

  return boostrapApplication;
})();
